<script>
import indicationService from "@/services/indication";
import patientService from "@/services/patient";

export default {
  name: "ModalResendPrescription",

  props: {
    visible: { type: Boolean, required: true },
    indication: { type: Object, default: null },
    patientId: { type: String, default: null },
    indicationTypeName: { type: String, default: "Indicación" },
    indicationTitle: { type: String, default: "" },
  },

  data() {
    return {
      targetEmail: "",
      isSending: false,
      isLoadingPatient: false,
    };
  },

  watch: {
    visible(val) {
      if (val) {
        this.targetEmail = "";
        this.loadPatientEmail();
      }
    },
  },

  methods: {
    async loadPatientEmail() {
      if (!this.patientId) return;
      this.isLoadingPatient = true;
      try {
        const patient = await patientService.getById(this.patientId);
        if (patient?.email) {
          this.targetEmail = patient.email;
        }
      } catch {
        // Si no se puede cargar el email, el usuario lo ingresa manualmente
      } finally {
        this.isLoadingPatient = false;
      }
    },

    async handleSend() {
      if (!this.targetEmail || !this.targetEmail.trim()) {
        this.$message.warning("Ingresá un email de destino");
        return;
      }

      this.isSending = true;
      try {
        await indicationService.resendEmail(
          this.indication._id,
          this.targetEmail.trim()
        );
        this.$message.success("Indicación reenviada correctamente");
        this.handleClose();
      } catch (error) {
        const msg =
          error.response?.data?.error || "Error al reenviar la indicación";
        this.$message.error(msg);
      } finally {
        this.isSending = false;
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<template lang="pug">
  el-dialog.modal-resend-prescription(
    :visible="visible"
    :before-close="handleClose"
    title="Reenviar indicación"
    width="480px"
  )
    .modal-body
      .medication-info
        p.medication-label {{ indicationTypeName }}
        p.medication-name {{ indicationTitle }}

      .email-section
        label.email-label Enviar a
        el-input(
          v-model="targetEmail"
          placeholder="Email de destino"
          :disabled="isLoadingPatient || isSending"
          @keyup.enter.native="handleSend"
        )
          template(#prefix)
            i.el-icon-message

    template(#footer)
      .dialog-footer
        button.button-blue-new(
          @click="handleSend"
          :disabled="isSending || isLoadingPatient || !targetEmail.trim()"
        ) {{ isSending ? 'Enviando...' : 'Enviar' }}
</template>

<style scoped>
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.medication-info {
  padding: 12px 16px;
  background-color: #f0f3fb;
  border-radius: 8px;
  border-left: 4px solid #405186;
}

.medication-label {
  font-size: 12px;
  color: #888;
  margin: 0 0 4px 0;
}

.medication-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e3270;
  margin: 0;
}

.email-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.email-label {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
